import React from 'react';
import styles from './Button.module.css';

const VARIANT_CLASS = {
    primary: 'primary',
    outline: 'outline',
    secondary: 'secondary',
    success: 'success',
    danger: 'danger',
    text: 'text',
    gold: 'gold',
};

export default function Button({
    variant = 'primary',
    type = 'button',
    disabled,
    onClick,
    children,
    className,
    ...rest
}) {
    const variantClass = styles[VARIANT_CLASS[variant] || VARIANT_CLASS.primary];

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            className={`${styles.button} ${variantClass} ${className || ''}`}
            {...rest}
        >
            {children}
        </button>
    );
}
